import { css } from 'styled-components';

// Constants
import { SCREEN, TEXT_COLORS, FONT_FAMILY } from './constants';
import { FONT_SIZE } from './font';

export const ellipsis = css`
	${props => props.ellipsis && css`
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: ${props.ellipsis};
	`};
`;

// Base text styles
export const baseText = css`
	${FONT_FAMILY.proximaNova};
	${ellipsis};
	color: ${TEXT_COLORS.BASE};
	${FONT_SIZE.BASE};

    ${SCREEN.SMALL} {
    	${FONT_SIZE.BASE_MOBILE};
    }
`;

export const readText = css`
	${FONT_FAMILY.proximaNova};
	${FONT_SIZE.READ};

    ${SCREEN.SMALL} {
    	${FONT_SIZE.BASE_MOBILE};
    }
`;

// Headline styles
export const heading1 = css`
	${FONT_FAMILY.proximaNovaSoft};
	${FONT_SIZE.H1};
	font-weight: 600;
	
    ${SCREEN.SMALL} {
        ${FONT_SIZE.H1_MOBILE};
    }
`;

export const heading2 = css`
	${FONT_FAMILY.proximaNovaSoft};
	${FONT_SIZE.H2};
	font-weight: 600;
	
    ${SCREEN.SMALL} {
       ${FONT_SIZE.H2_MOBILE};
    }
`;

export const heading3 = css`
	${FONT_FAMILY.proximaNovaSoft};
	${FONT_SIZE.H3};
	font-weight: 600;
	
    ${SCREEN.SMALL} {
    	${FONT_SIZE.H2_MOBILE};
    }
`;

export const heading4 = css`
	${FONT_FAMILY.proximaNovaSoft};
	${FONT_SIZE.H4};
	font-weight: 600;

    ${SCREEN.SMALL} {
    	${FONT_SIZE.BASE_MOBILE};
    }
`;

export const heading5 = css`
	${FONT_FAMILY.proximaNovaSoft};
	${FONT_SIZE.H5};
	font-weight: 600;

    ${SCREEN.SMALL} {
    	${FONT_SIZE.BASE_MOBILE};
    }
`;

export const heading6 = css`
	${FONT_FAMILY.proximaNovaSoft};
	${FONT_SIZE.BASE};
	font-weight: 600;
	
	${SCREEN.SMALL} {
		${FONT_SIZE.BASE_MOBILE};
    }
`;

// Other styles
export const baseCaption = css`
	${FONT_FAMILY.proximaNova};
	color: ${TEXT_COLORS.LIGHT};
	${FONT_SIZE.CAPTION};
`;

export const baseTag = css`
	${FONT_FAMILY.proximaNova};
	color: ${TEXT_COLORS.BASE};
	${FONT_SIZE.TAG};
	font-weight: 800;
	letter-spacing: 0.2px;
	text-transform: uppercase;
	font-kerning: normal;
`;
